import { axiosInstance } from "../../utils";

const actions = {
    FETCH_COUPONS_REQUESTED: 'FETCH_COUPONS_REQUESTED',
    FETCH_COUPONS_SUCCEEDED: 'FETCH_COUPONS_SUCCEEDED',
    FETCH_COUPONS_FAILED: 'FETCH_COUPONS_FAILED',

    FETCH_COUPON_REQUESTED: 'FETCH_COUPON_REQUESTED',
    FETCH_COUPON_SUCCEEDED: 'FETCH_COUPON_SUCCEEDED',
    FETCH_COUPON_FAILED: 'FETCH_COUPON_FAILED',

    DELETE_COUPON_REQUESTED: 'DELETE_COUPON_REQUESTED',
    DELETE_COUPON_SUCCEEDED: 'DELETE_COUPON_SUCCEEDED',
    DELETE_COUPON_FAILED: 'DELETE_COUPON_FAILED',
    
    CLEAR_COUPON: 'CLEAR_COUPON',

    removeCoupon: (id = undefined) => {
        return {
            type: actions.DELETE_COUPON_REQUESTED,
            payload: id
        }
    },

    deleteCoupon: async (id = undefined) => {
        const url = `coupons/`+id;

        try {
            const response = await axiosInstance.delete(url);
            return response.data;
        } catch (error) {
            throw error;
        }
    },

    fetchCoupons: (params = undefined) => {
        return {
            type: actions.FETCH_COUPONS_REQUESTED,
            payload: params
        }
    },

    fetchCoupon: (id = undefined) => {
        return {
            type: actions.FETCH_COUPON_REQUESTED,
            payload: id
        }
    },

    getCoupons: async (params = undefined) => {
        const url = `coupons`;

        try {
            const coupons = await axiosInstance.get(url,{ params });
            return coupons.data;
        } catch (error) {
            throw error;
        }
    },

    getCoupon: async (couponId = undefined) => {
        const url = `coupons/`+couponId;

        try {
            const coupon = await axiosInstance.get(url);
            return coupon.data;
        } catch (error) {
            throw error;
        }
    }
};
export default actions;
